<template>
	<p class="has-text-centered">
    	&copy; 2013-{{ currentYear }} Geneasens SRL - Tous droits réservés.
	</p>
</template>

<script>
    export default {
        computed: {
        	currentYear() {
				return new Date().getFullYear();
        	}
        }
	}
</script>